export default __webpack_public_path__ + "static/media/girl_child.475ce32e.jpg";